
const CALIFORNIA = 'CA';
const IDAHO = 'ID';
const ILLINOIS = 'IL';
const NEVADA = 'NV';
const MINNESOTA = 'MN';
const PENNSYLVANIA = 'PA';
const NEW_JERSEY = 'NJ';
const NEW_MEXICO = 'NM';
const GEORGIA = 'GA';
const VIRGINIA = 'VA';
const GETINSURED = 'GI';

export type STATES_TYPE =
    | 'CA'
    | 'GA'
    | 'ID'
    | 'IL'
    | 'MN'
    | 'NJ'
    | 'NM'
    | 'NV'
    | 'PA'
    | 'VA'
    | 'GI';

export default {
    CALIFORNIA,
    IDAHO,
    ILLINOIS,
    MINNESOTA,
    NEVADA,
    PENNSYLVANIA,
    NEW_JERSEY,
    NEW_MEXICO,
    GEORGIA,
    VIRGINIA,
    GETINSURED
};

export const STATE_NAMES = {
    [CALIFORNIA]: 'California',
    [IDAHO]: 'Idaho',
    [ILLINOIS]: 'Illinois',
    [NEVADA]: 'Nevada',
    [MINNESOTA]: 'Minnesota',
    [PENNSYLVANIA]: 'Pennsylvania',
    [NEW_JERSEY]: 'New Jersey',
    [NEW_MEXICO]: 'New Mexico',
    [GEORGIA]: 'Georgia',
    [VIRGINIA]: 'Virginia',
    [GETINSURED]: 'Getinsured'
};
export const STATE_STYLES = {
    [CALIFORNIA]: '../../../assets/scss/index/index_CA',
    [IDAHO]: '../../../assets/scss/index/index_ID.css',
    [NEVADA]: '../../../assets/scss/index/index_NV.css',
    [MINNESOTA]: '../../../assets/scss/index/index_MN.css',
    [PENNSYLVANIA]: '../../../assets/scss/index/index_PA.css',
    [NEW_JERSEY]: '../../../assets/scss/index/index_NJ.css',
    [NEW_MEXICO]: '../../../assets/scss/index/index_NM.css',
    [GEORGIA]: '../../../assets/scss/index/index_GA.css',
    [VIRGINIA]: '../../../assets/scss/index/index_VA.css',
    [ILLINOIS]: '../../../assets/scss/index/index_IL.css',
    [GETINSURED]: '../../../assets/scss/index/index_GI.css'
};

export enum IEX_STATE_CODES {
    IEX = 'IEX',
    FL = 'FL',
    GA = 'GA',
    ID = 'ID',
    KY = 'KY',
    MN = 'MN',
    MO = 'MO',
    NJ = 'NJ',
    NM = 'NM',
    NV = 'NV',
    PA = 'PA',
    VA = 'VA',
    IL = 'IL',
    WA = 'WA',
    CA = 'CA',
    GI = 'GI'
};

